import { mapGetters } from 'vuex';

import { format } from 'date-fns';

export const authComputed = {
  ...mapGetters(['loggedIn', 'getUserData', 'getJwtToken', 'getCandidate']),
};

export const formmatedDate = (date, dateFormat) => {
  return format(new Date(date), dateFormat);
};
